export default __webpack_public_path__ + "static/media/theodercafe.3775f160.png";